/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserGuide200Response
 */
export interface GetUserGuide200Response {
    /**
     * 
     * @type {string}
     * @memberof GetUserGuide200Response
     */
    url?: string;
}

/**
 * Check if a given object implements the GetUserGuide200Response interface.
 */
export function instanceOfGetUserGuide200Response(value: object): value is GetUserGuide200Response {
    return true;
}

export function GetUserGuide200ResponseFromJSON(json: any): GetUserGuide200Response {
    return GetUserGuide200ResponseFromJSONTyped(json, false);
}

export function GetUserGuide200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserGuide200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function GetUserGuide200ResponseToJSON(json: any): GetUserGuide200Response {
    return GetUserGuide200ResponseToJSONTyped(json, false);
}

export function GetUserGuide200ResponseToJSONTyped(value?: GetUserGuide200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

